import { Button, Form, Modal } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
} from "../../../features/RadConnStyle";
import axios from "axios";
import { HttpJsonHeader } from "../../../features/Environments";
import { useDispatch, useSelector } from "react-redux";
import { setReminder } from "../../../features/UserActions";
import styled from "styled-components";

export default function UserRuleMenuConfig(props) {
  const userDetail = useSelector((state) => state.user.detail);
  const [winState, setWinState] = props.state;
  const [data, setData] = useState(null);
  const { selectedRow } = props;
  const dispatch = useDispatch();

  //----------------------------------------------------------------------
  useEffect(() => {
    if (selectedRow && selectedRow.row) {
      getData();
    }
  }, [selectedRow]);

  //----------------------------------------------------------------------
  const getData = () => {
    axios
      .post(
        process.env.REACT_APP_API + "api/userrule/get-rule-menu-conf-list",
        selectedRow.row,
        HttpJsonHeader
      )
      .then((res) => {
        if (res.data) {
          setData(res.data);
        }
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  };

  //----------------------------------------------------------------------

  const saveData = () => {
    let dataTosave = {
      ItemId: selectedRow.row.ruleid,
      SaveInfo: data.AllMenus,
      UserInfo: userDetail,
    };

    axios
      .post(
        process.env.REACT_APP_API + "api/userrule/update-rule-menu",
        dataTosave,
        HttpJsonHeader
      )
      .then((res) => {
        setData(res.data);
        dispatch(
          setReminder({ show: true, message: "บันทึกสมบูรณ์", type: "success" })
        );
        setWinState({ show: false });
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  };
  //----------------------------------------------------------------------
  return (
    <MyModal
      show={winState.show}
      size="sm"
      centered
      backdrop={false}
      onHide={() => {
        setWinState({ show: false });
      }}
    >
      <ModalHeaderBlack style={{ textAlign: "center" }} closeButton>
        เมนู
        <span style={{ color: "#5af94f" }}>
          {selectedRow && selectedRow.row.ruleshort}
        </span>
      </ModalHeaderBlack>

      <ModalBodyBlack>
        <HBox style={{ backgroundColor: "#1f1d1d" }}>
          <VBox
            style={{ width: "auto", marginLeft: "auto", marginRight: "auto" }}
          >
            {data &&
              data.AllMenus.map((item, i) => {
                return (
                  <Form.Check
                    key={item.mnu_origin_id}
                    name={item.mnu_origin_id}
                    style={{ color: "#7cb6fe" }}
                    type="switch"
                    label={item.menutext}
                    defaultChecked={item.mnu_user_id > 0 ? true : false}
                    onChange={(e) => {
                      item.mnu_user_id = e.target.checked
                        ? item.mnu_origin_id
                        : -1;
                    }}
                  />
                );
              })}
          </VBox>
        </HBox>
      </ModalBodyBlack>

      <ModalFooterBlack>
        <Button variant="primary" onClick={() => saveData()}>
          Save changes
        </Button>
        <Button variant="danger" onClick={() => setWinState({ show: false })}>
          Close
        </Button>
      </ModalFooterBlack>
    </MyModal>
  );
}

const HBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
const VBox = styled.div`
  flex: 1;
  padding: 10px 20px 20px 30px;
  background-color: #1f1d1d;
`;
